<template>
  <div class="multiple-locations-manager">
    <!-- Mapa sempre visível -->
    <div class="map-section mb-3" :class="{ 'map-picking': isAddingPin || movingIndex !== null }">
      <div class="map-container">
        <GoogleMap :showlayers="true" ref="mainMap" @click="onMapClick" :showMapTypeToggle="true" mapTypeTogglePlacement="bottom">
          <template v-slot:body>
            <!-- Campo de busca de cidades -->
            <MapSearchBox :map="$refs.mainMap ? $refs.mainMap.map : null" :embedded="true" />

            <!-- Botão de adicionar pin dentro do mapa -->
            <div class="map-add-button">
              <button
                type="button"
                class="map-add-btn"
                @click="toggleAddMode"
                :class="{ 'is-adding': isAddingPin }"
                :title="isAddingPin ? 'Cancelar' : 'Adicionar um novo pin'">
                <i :class="isAddingPin ? 'bx bx-x' : 'bx bx-map-pin'"></i>
                <span>{{ isAddingPin ? 'Clique no mapa para adicionar' : 'Adicionar Pin' }}</span>
              </button>
            </div>

            <!-- Aviso do modo "mudar localização" (botão da lista) -->
            <div v-if="movingIndex !== null && locations[movingIndex]" class="map-move-banner">
              <span>
                Clique no mapa para o novo local de
                <strong>{{ locations[movingIndex].nome || `Pin ${movingIndex + 1}` }}</strong>
              </span>
              <button type="button" class="btn btn-sm btn-light" @click="cancelMove">Cancelar</button>
            </div>

            <!-- <div v-if="isAddingPin" class="map-instruction">
              <div class="alert alert-info m-3">
                <i class="fas fa-hand-pointer me-2"></i>
                Clique no mapa para adicionar o pin
              </div>
            </div> -->
          </template>
        </GoogleMap>
      </div>
    </div>

    <!-- Lista de pins adicionados -->
    <div v-if="locations.length > 0" class="locations-list mb-3">
      <h6 class="mb-3">Pins Adicionados ({{ locations.length }})</h6>

      <!-- Versão Desktop (Tabela) -->
      <div class="table-responsive d-none d-md-block">
        <table class="table table-sm table-hover table-striped">
          <thead>
            <tr>
              <th style="width: 80px">Cor do Pin</th>
              <th>Nome</th>
              <th>Latitude</th>
              <th>Longitude</th>
              <th style="width: 100px">Principal</th>
              <th style="width: 100px">Ações</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(location, index) in locations" :key="index">
              <!-- Linha normal do pin -->
              <tr v-if="pinToDelete !== index" :class="{ 'pin-row-moving': movingIndex === index }">
                <td>
                  <input
                    type="color"
                    class="form-control form-control-color"
                    v-model="location.cor"
                    title="Escolha a cor do pin"
                    style="width: 60px; height: 38px; padding: 2px;"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :class="{ 'is-invalid': !location.nome || location.nome.trim() === '' }"
                    v-model="location.nome"
                    :placeholder="`Pin ${index + 1}`"
                    maxlength="100"
                    required
                  />
                  <div class="invalid-feedback" v-if="!location.nome || location.nome.trim() === ''">
                    Nome obrigatório
                  </div>
                </td>
                <td>
                  <small class="text-muted">{{ parseFloat(location.latitude).toFixed(6) }}</small>
                </td>
                <td>
                  <small class="text-muted">{{ parseFloat(location.longitude).toFixed(6) }}</small>
                </td>
                <td>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      :name="'principal-' + componentId"
                      :checked="location.principal"
                      @change="setPrincipal(index)"
                    />
                    <label class="form-check-label">
                      <small>Principal</small>
                    </label>
                  </div>
                </td>
                <td class="text-center text-nowrap">
                  <button
                    type="button"
                    class="btn btn-white p-0 me-3"
                    :class="{ 'pin-move-active': movingIndex === index }"
                    @click="toggleMove(index)"
                    :title="movingIndex === index ? 'Cancelar mudança de local' : 'Mudar localização (ou arraste o pin no mapa)'">
                    <i class="bx bx-current-location text-primary"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-white p-0"
                    @click="removeLocation(index)"
                    :disabled="locations.length === 1"
                    :title="locations.length === 1 ? 'A propriedade precisa ter pelo menos 1 pin' : 'Remover pin'">
                    <i class="bx bx-trash text-danger"></i>
                  </button>
                </td>
              </tr>

              <!-- Linha de confirmação de exclusão -->
              <tr v-else class="bg-danger-subtle">
                <td colspan="6" class="text-center py-3">
                  <div class="d-flex align-items-center justify-content-center gap-3">
                    <i class="bx bx-error-circle text-danger fs-4"></i>
                    <span class="fw-semibold">
                      Deseja realmente excluir o pin
                      <strong>{{ location.nome || `Pin ${index + 1}` }}</strong>?
                    </span>
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-secondary" @click="cancelDelete">
                        Cancelar
                      </button>
                      <button type="button" class="btn btn-sm btn-danger" @click="confirmDelete">
                        Excluir
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- Versão Mobile (Cards) -->
      <div class="d-md-none">
        <template v-for="(location, index) in locations" :key="index">
          <!-- Card normal do pin -->
          <div v-if="pinToDelete !== index" class="card mb-3" :class="{ 'pin-card-moving': movingIndex === index }">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <input
                  type="color"
                  class="form-control form-control-color"
                  v-model="location.cor"
                  title="Escolha a cor do pin"
                  style="width: 60px; height: 40px; padding: 2px;"
                />
                <button
                  type="button"
                  class="btn btn-white p-0"
                  @click="removeLocation(index)"
                  :disabled="locations.length === 1"
                  :title="locations.length === 1 ? 'A propriedade precisa ter pelo menos 1 pin' : 'Remover pin'">
                  <i class="bx bx-trash text-danger fs-5"></i>
                </button>
              </div>

              <div class="mb-3">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  :class="{ 'is-invalid': !location.nome || location.nome.trim() === '' }"
                  v-model="location.nome"
                  :placeholder="`Nome do Pin ${index + 1}`"
                  maxlength="100"
                  required
                />
                <div class="invalid-feedback" v-if="!location.nome || location.nome.trim() === ''">
                  Nome obrigatório
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-6">
                  <label class="form-label small text-muted mb-1">Latitude</label>
                  <div class="text-muted small">{{ parseFloat(location.latitude).toFixed(6) }}</div>
                </div>
                <div class="col-6">
                  <label class="form-label small text-muted mb-1">Longitude</label>
                  <div class="text-muted small">{{ parseFloat(location.longitude).toFixed(6) }}</div>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-sm w-100 mb-3"
                :class="movingIndex === index ? 'btn-secondary' : 'btn-outline-primary'"
                @click="toggleMove(index)">
                <i class="bx bx-current-location me-1"></i>
                {{ movingIndex === index ? 'Cancelar mudança de local' : 'Mudar localização' }}
              </button>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  :name="'principal-mobile-' + componentId"
                  :checked="location.principal"
                  @change="setPrincipal(index)"
                />
                <label class="form-check-label">
                  Marcar como Principal
                </label>
              </div>
            </div>
          </div>

          <!-- Card de confirmação de exclusão -->
          <div v-else class="card mb-3 border-danger">
            <div class="card-body bg-danger-subtle text-center py-4">
              <i class="bx bx-error-circle text-danger fs-3 mb-2"></i>
              <p class="mb-3">
                Deseja realmente excluir o pin<br>
                <strong>{{ location.nome || `Pin ${index + 1}` }}</strong>?
              </p>
              <div class="d-grid gap-2">
                <button type="button" class="btn btn-secondary" @click="cancelDelete">
                  Cancelar
                </button>
                <button type="button" class="btn btn-danger" @click="confirmDelete">
                  Excluir
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div class="alert alert-secondary alert-sm mt-2">
        <!-- <i class="fas fa-info-circle me-2"></i> -->
        <small>O pin marcado como "Principal" será usado como localização padrão da propriedade.</small>
      </div>
    </div>

    <!-- Mensagem quando não há pins -->
    <div v-else class="alert alert-secondary">
      <!-- <i class="fas fa-exclamation-triangle me-2"></i> -->
      Nenhum pin adicionado. Clique em "Adicionar Pin" e depois clique no mapa para marcar uma localização.
    </div>
  </div>
</template>

<script>
import GoogleMap from './mapa/GoogleMap.vue'
import MapSearchBox from './mapa/MapSearchBox.vue'

export default {
  name: 'MultipleLocationsManager',
  components: {
    GoogleMap,
    MapSearchBox
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      locations: [],
      componentId: Math.random().toString(36).substr(2, 9),
      isAddingPin: false,
      pinToDelete: null,
      // Índice do pin em "mudar localização": o próximo clique no mapa o reposiciona.
      movingIndex: null
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && Array.isArray(newVal) && newVal.length > 0) {
          // Se recebeu array com pins, sempre atualizar
          this.locations = JSON.parse(JSON.stringify(newVal))
          this.$nextTick(() => {
            this.updateMapMarkers()
          })
        } else if (!newVal || (Array.isArray(newVal) && newVal.length === 0)) {
          // Se recebeu array vazio ou null, só resetar se locations não estiver preenchido
          if (!this.locations || this.locations.length === 0) {
            this.locations = []
          }
        }
      }
    },
    locations: {
      deep: true,
      handler(newVal) {
        this.$emit('input', newVal)
        this.$emit('change', newVal)
        this.$nextTick(() => {
          this.updateMapMarkers()
        })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.setupMap()
        // Alterar para modo híbrido (satélite + ruas) após o mapa carregar
        if (this.$refs.mainMap && this.$refs.mainMap.map) {
          this.$refs.mainMap.map.setMapTypeId('hybrid')

          // Aplicar estilos customizados para ocultar POIs (lojas, restaurantes, etc)
          // mas manter as labels das ruas
          this.$refs.mainMap.map.setOptions({
            styles: [
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'poi.business',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'poi.park',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'poi.school',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'poi.medical',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'poi.government',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'poi.place_of_worship',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'poi.sports_complex',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'transit',
                stylers: [{ visibility: 'off' }]
              }
            ]
          })
        }
      }, 500) // Dar tempo para o Google Maps carregar
    })
  },
  methods: {
    setupMap() {
      if (!this.$refs.mainMap) return

      // Configurar evento de adicionar marcador para Google Maps
      // Assinatura: (point, markerGroup, mapComponent)
      this.$refs.mainMap.event.add = this.addMarker

      // Se já tem locais, centralizar no pin principal (ou no primeiro se não houver principal)
      if (this.locations.length > 0) {
        const principalLocation = this.locations.find(l => l.principal) || this.locations[0]
        this.$refs.mainMap.move(principalLocation.latitude, principalLocation.longitude, 13)
      } else {
        // Tentar obter localização do usuário
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              this.$refs.mainMap.move(position.coords.latitude, position.coords.longitude, 13)
            },
            () => {
              // Se usuário negar, não fazer nada - deixar na posição padrão do mapa
              console.log('Localização do usuário negada')
            }
          )
        }
      }

      this.updateMapMarkers()
    },

    createMarkerSVG(color) {
      // Criar SVG de pin estilo GPS/localização
      return `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
        <path d="M16 0C7.2 0 0 7.2 0 16c0 8.8 16 26 16 26s16-17.2 16-26C32 7.2 24.8 0 16 0z"
              fill="${color}"
              stroke="white"
              stroke-width="2"/>
        <circle cx="16" cy="16" r="6" fill="white"/>
      </svg>`
    },

    updateMapMarkers() {
      if (!this.$refs.mainMap || !this.$refs.mainMap.map) {
        return
      }

      // Garantir que o event.add esteja configurado
      if (!this.$refs.mainMap.event.add) {
        this.$refs.mainMap.event.add = this.addMarker
      }

      const points = this.locations.map((loc, index) => ({
        index,
        latitude: loc.latitude,
        longitude: loc.longitude,
        nome: loc.nome || 'Pin sem nome',
        principal: loc.principal,
        cor: loc.cor
      }))

      // Sem agrupamento: cada pin precisa ser um marcador próprio para poder ser
      // arrastado e editado (o cluster juntaria pins próximos num marcador só).
      this.$refs.mainMap.addPoints(points, null, false)
    },

    addMarker(point, markerGroup, mapComponent) {
      const svgMarker = this.createMarkerSVG(point.cor || '#dc3545')
      const marker = mapComponent.addMarkerWithCustomIcon(
        point.latitude,
        point.longitude,
        svgMarker,
        point.nome || 'Pin sem nome'
      )
      if (!marker) return

      // Arrastar o pin no mapa muda a localização dele.
      marker.setDraggable(true)
      marker.addListener('dragend', (e) => {
        this.setLocationPosition(point.index, e.latLng.lat(), e.latLng.lng())
      })

      // O pin em "mudar localização" fica pulando para destacar qual vai mudar.
      if (this.movingIndex === point.index) {
        marker.setAnimation(google.maps.Animation.BOUNCE)
      }
    },

    setLocationPosition(index, lat, lng) {
      const loc = this.locations[index]
      if (!loc) return
      loc.latitude = lat
      loc.longitude = lng
      this.movingIndex = null
    },

    toggleMove(index) {
      if (this.movingIndex === index) {
        this.cancelMove()
        return
      }
      this.isAddingPin = false
      this.movingIndex = index

      // Centraliza no pin e traz o mapa para a tela (no celular a lista fica abaixo dele).
      const loc = this.locations[index]
      if (this.$refs.mainMap && loc) {
        this.$refs.mainMap.move(loc.latitude, loc.longitude, this.$refs.mainMap.getZoom())
      }
      const mapSection = this.$el.querySelector('.map-section')
      if (mapSection) mapSection.scrollIntoView({ behavior: 'smooth', block: 'center' })

      this.updateMapMarkers()
    },

    cancelMove() {
      this.movingIndex = null
      this.updateMapMarkers()
    },

    toggleAddMode() {
      this.isAddingPin = !this.isAddingPin
      if (this.isAddingPin && this.movingIndex !== null) this.cancelMove()
    },

    onMapClick(event) {
      if (this.movingIndex !== null && event && event.latlng) {
        this.setLocationPosition(this.movingIndex, event.latlng.lat, event.latlng.lng)
        return
      }

      if (!this.isAddingPin) return

      // O evento do Google Maps vem como { latlng: { lat, lng } }
      if (event && event.latlng) {
        const isPrincipal = this.locations.length === 0

        this.locations.push({
          latitude: event.latlng.lat,
          longitude: event.latlng.lng,
          tipo: 'PONTO',
          nome: '',
          principal: isPrincipal,
          cor: this.getNextColor()
        })

        this.isAddingPin = false
        this.$emit('pin-added', this.locations[this.locations.length - 1])
      }
    },

    getNextColor() {
      // Paleta de cores diferentes para cada pin
      const colors = [
        '#dc3545', // vermelho
        '#0d6efd', // azul
        '#198754', // verde
        '#ffc107', // amarelo
        '#6f42c1', // roxo
        '#fd7e14', // laranja
        '#20c997', // turquesa
        '#d63384', // rosa
        '#0dcaf0', // ciano
        '#6c757d'  // cinza
      ]
      return colors[this.locations.length % colors.length]
    },

    removeLocation(index) {
      if (this.locations.length === 1) {
        // Não permitir excluir se for o último pin
        return
      }
      this.pinToDelete = index
    },

    confirmDelete() {
      if (this.pinToDelete !== null) {
        const removedLocation = this.locations[this.pinToDelete]
        const wasPrincipal = removedLocation.principal

        // Os índices mudam com a remoção: encerra qualquer "mudar localização" em curso.
        this.movingIndex = null
        this.locations.splice(this.pinToDelete, 1)

        // Se removeu o principal e ainda tem pins, definir o primeiro como principal
        if (wasPrincipal && this.locations.length > 0) {
          this.locations[0].principal = true
        }

        // Forçar atualização imediata dos marcadores no mapa
        this.$nextTick(() => {
          this.updateMapMarkers()
        })

        this.$emit('pin-removed', removedLocation)
        this.pinToDelete = null
      }
    },

    cancelDelete() {
      this.pinToDelete = null
    },

    setPrincipal(index) {
      this.locations.forEach((loc, i) => {
        loc.principal = i === index
      })

      // Forçar reatividade
      this.locations = [...this.locations]
    },

    validate() {
      if (this.locations.length === 0) {
        return {
          isValid: false,
          message: 'Adicione pelo menos um pin de localização'
        }
      }

      const pinsWithoutName = this.locations.filter(loc => !loc.nome || loc.nome.trim() === '')
      if (pinsWithoutName.length > 0) {
        return {
          isValid: false,
          message: `${pinsWithoutName.length} pin(s) sem nome. Preencha o nome de todos os pins.`
        }
      }

      const hasPrincipal = this.locations.some(loc => loc.principal)
      if (!hasPrincipal) {
        return {
          isValid: false,
          message: 'Marque um pin como principal'
        }
      }

      return { isValid: true }
    }
  }
}
</script>

<style scoped>
.multiple-locations-manager {
  width: 100%;
}

.map-add-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  pointer-events: auto;
}

/* Mesma altura e cantos do campo de busca, para os dois controles do topo
   terem o mesmo peso visual sobre o satélite. */
.map-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 46px;
  padding: 0 18px;
  border: none;
  border-radius: 8px;
  background: #006035;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}
.map-add-btn i {
  font-size: 20px;
}
.map-add-btn:hover {
  background: #004d2a;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);
}
/* Modo adicionando: fundo branco com borda verde pulsando, para não passar
   despercebido que o próximo clique no mapa cria um pin. */
.map-add-btn.is-adding {
  background: #ffffff;
  color: #006035;
  box-shadow: 0 0 0 3px #78a64e, 0 2px 10px rgba(0, 0, 0, 0.35);
  animation: map-add-pulse 1.4s ease-in-out infinite;
}
@keyframes map-add-pulse {
  0%, 100% { box-shadow: 0 0 0 3px #78a64e, 0 2px 10px rgba(0, 0, 0, 0.35); }
  50% { box-shadow: 0 0 0 7px rgba(120, 166, 78, 0.45), 0 2px 10px rgba(0, 0, 0, 0.35); }
}

/* Mira no mapa enquanto o próximo clique define um local (adicionar ou mover). */
.map-picking :deep(.gm-style > div),
.map-picking :deep(.gm-style div) {
  cursor: crosshair !important;
}

/* Responsivo para mobile */
@media (max-width: 767px) {
  .map-add-button {
    top: 64px;
    left: 10px;
    right: 10px;
  }

  .map-add-btn {
    width: 100%;
    height: 44px;
    font-size: 14px;
  }
}

.map-container {
  position: relative;
  height: 400px;
}

/* No celular a busca, o "Adicionar Pin", o aviso de mover e o switch ocupam boa parte
   dos 400px: o mapa cresce com a tela para sobrar área útil para clicar. */
@media (max-width: 767px) {
  .map-container {
    height: 65vh;
    min-height: 480px;
  }
}

.map-move-banner .btn,
.pin-card-moving .btn,
.card .btn.w-100 {
  font-size: 13px;
  line-height: 1.3;
}

.map-move-banner {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 1000;
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: calc(100% - 20px);
  padding: 8px 8px 8px 14px;
  border-radius: 8px;
  background: #006035;
  color: #ffffff;
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Linha/card do pin em "mudar localização" */
.pin-row-moving > td {
  background-color: #e8f3ec !important;
}
.pin-card-moving {
  border-color: #006035;
  box-shadow: 0 0 0 2px rgba(0, 96, 53, 0.25);
}
.pin-move-active i {
  color: #006035 !important;
}

/* No celular o switch Terreno/Satélite ocupa o canto inferior: o aviso sobe. */
@media (max-width: 767px) {
  .map-move-banner {
    bottom: 64px;
    right: 10px;
    justify-content: space-between;
  }
}

.map-instruction {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  pointer-events: none;
}

@media (max-width: 767px) {
  .map-instruction {
    top: 110px;
  }
}

.map-instruction .alert {
  pointer-events: auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.locations-list {
  margin-top: 20px;
}

.table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 0;
}

.table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
  padding: 12px;
}

.table tbody td {
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.table tbody tr:last-child td {
  border-bottom: none;
}

.table tbody tr:hover {
  background-color: #f8f9fa !important;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

.table-striped tbody tr:nth-of-type(even) {
  background-color: #ffffff;
}

.bg-danger-subtle {
  background-color: #f8d7da !important;
  border-left: 4px solid #dc3545;
}

.pin-marker-multi {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
